export enum SortingOrder {
  ASC = 'asc',
  DESC = 'desc',
  AUTO = 'auto',
}
